export default __webpack_public_path__ + "static/media/i-plus.a9a4e685.svg";